import { Popconfirm } from "antd";
import { FC } from "react";

import {
    StyledConfirmBtn,
    StyledConfirmBtnContainer,
} from "./ConfirmActionBtn.styled";

interface ConfirmActionBtnProps {
    loading: boolean;
    onConfirm: () => void;
    title?: string;
    description?: string;
    okText?: string;
    cancelText?: string;
    btnText?: string;
}

export const ConfirmActionBtn: FC<ConfirmActionBtnProps> = ({
    loading,
    onConfirm,
    title = "Підтвердити дію",
    description = "Ви впевнені, що хочете виконати цю дію?",
    okText = "Так",
    cancelText = "Ні",
    btnText = "Підтвердити",
}) => (
    <StyledConfirmBtnContainer>
        <Popconfirm
            title={title}
            description={description}
            onConfirm={onConfirm}
            okText={okText}
            cancelText={cancelText}
            disabled={loading}
        >
            <StyledConfirmBtn type="primary" loading={loading}>
                {btnText}
            </StyledConfirmBtn>
        </Popconfirm>
    </StyledConfirmBtnContainer>
);
